import React from 'react';
import { useSelector } from 'react-redux'
import { AppState } from '../../../store'
import { IDocumentsLinksConfigObjectModel } from '../../../store/types'
import { Link } from 'react-router-dom'
import GetLoanButton from '../../../components/Buttons/GetLoanButton/GetLoanButton'

import './DocsToDownloadPageContent.scss'


const DocToDownloadButtonsPanel = () => {

   const lenConfigState = useSelector((state: AppState) => state.lenConfigState)
   const { documentsLinksConfig } = lenConfigState

   const currentlyUsedLinks = [ // tablica z obecnie używanymi linkami 
      documentsLinksConfig.contractTemplate,
      documentsLinksConfig.informationClause,
      documentsLinksConfig.informationForm,
      documentsLinksConfig.privacyPolicy,
   ]

   const handleOnMouseDown = (e: React.MouseEvent<HTMLAnchorElement>, link: string) => {
      e.preventDefault() //Blokujemy akcję kliknięcia w przycisk
      window.open(link, '_blank') //Otwieramy pełen link w nowej karcie
   }

   return (
      <div className='docs-to-download-buttons-wrapper'>
         {
            currentlyUsedLinks.map((currentlyUsedLink: IDocumentsLinksConfigObjectModel, index: number) => {
               return (
                  <Link 
                     key={index}
                     onMouseDown={(e: React.MouseEvent<HTMLAnchorElement>) => handleOnMouseDown(e, currentlyUsedLink.path)} 
                     to={currentlyUsedLink.displayedLink} 
                     className='docs-to-download-single-button'
                  >
                     {currentlyUsedLink.text}
                  </Link>
               )
            })
         }
      </div>
   )
}

const DocToDownloadPageContent = () => {

   return (
      <section>
         <header className='docs-to-download-page-main-content-heading '>
            <h2>Zapoznaj się <br /> z naszymi dokumentami</h2>
            <hr className='separator docs-to-download-page-main-content-heading-separator'/>
         </header>
         <DocToDownloadButtonsPanel />
         <GetLoanButton additionalClassName='docs-to-download-page-content-section-loan-button' />
      </section>
   )
}

export default DocToDownloadPageContent